import React from 'react'
import { useAccountTypes } from '../../providers'
import Mortgage from './Mortgage'
import { LobShell, PartialOutageNotice } from '../Shared'

export const HomeLoans: React.FC = () => {
  const { allMortgageAccounts, isMortgageFullOutage } = useAccountTypes()
  if (allMortgageAccounts.length === 0 && !isMortgageFullOutage) return null
  return (
    <LobShell header="Home Loans" customizeTriggerLob="Homeloan">
      {isMortgageFullOutage ? (
        <PartialOutageNotice lob="homeloan" />
      ) : (
        <Mortgage />
      )}
    </LobShell>
  )
}
